module.exports = __webpack_public_path__ + "static/media/not_ready.9d9d02de.mp3";